import React, { useEffect, useState } from "react";
import st from './Filters.module.scss';
import { useTypedSelector } from "@hooks/useTypedSelector";
import { SelectorCropTNode } from "../../../../../store/reducers/dashboard/crops/selector/types";
import { useActions } from "@hooks/useActions";
import { Button2, IconBox, ModalWindow, Type as T } from "@infobis/ui-styles-utils";
import colors from "@infobis/ui-styles-utils/colors";
import CropsFilter from "../CropsFilter/CropsFilter";

const Filters = () => {
	const { selected = [] } = useTypedSelector(state => state.cropSelector)
	const [filtersOpen, setFiltersOpen] = useState(false)
	const [pickedCrops, setPickedCrops] = useState<SelectorCropTNode[]>(selected)
	const { setCurrentCrop } = useActions()

	useEffect(() => {
		setPickedCrops(selected)
	}, [selected]);

	const onWindowHide = () => {
		setFiltersOpen(false)
		setPickedCrops(selected)
	}

	const onSubmit = () => {
		setCurrentCrop(pickedCrops)
		setFiltersOpen(false)
	}

	return (
		<>
			<Button2.Contrast.IconL icon={T.IconName.Filter} size={T.Sizes.S} onClick={() => setFiltersOpen(true)}>
				Фильтры
			</Button2.Contrast.IconL>
			{filtersOpen &&
                <ModalWindow overlayStyle={{ justifyContent: 'end' }}
                             outsideClickAction={onWindowHide}
                             className={st['filters__content']}>
                    <div className={st['filters__content-container']}>
                        <div className={st["filters__content-title"]}>
                            <span className={st["filters__content-title__text"]}>Фильтры по дашбордам</span>
                            <IconBox icon={T.IconName.Cancel}
                                     style={{ cursor: 'pointer' }}
                                     color={colors.CONTROL_DEFAULT_ICON_ICON}
                                     onClick={onWindowHide}
                                     size={T.Sizes.M}/>
                        </div>
                        <CropsFilter pickedCrops={pickedCrops} setPickedCrops={setPickedCrops} />
                    </div>
                    <div className={st['filters__content-footer']}>
                        <Button2.Clear onClick={onWindowHide} size={T.Sizes.S}>Отмена</Button2.Clear>
                        <Button2.Secondary onClick={onSubmit} size={T.Sizes.S}>Применить</Button2.Secondary>
                    </div>
                </ModalWindow>
			}
		</>
	)
}

export default Filters;